var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('home-header'),_c('landing'),_c('what-is-vibrix',{staticClass:"widthbox"}),_c('fab',{staticClass:"my-8 widthbox"}),_c('home-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }